<template #default>
    <form
        v-if="status.detail"
        @submit.prevent="propertyAreaUnitUUID ? requestUpdate() : requestCreate()"
    >
        <b-form-group
            :label="$t('label.name')"
            label-cols="4"
            label-align="left"
        >
            <b-form-input
                v-model.trim="createForm.name"
                :class="{ 'is-invalid': submitted && !$v.createForm.name.required }"
                autocomplete="off"
            ></b-form-input>
            <b-form-invalid-feedback v-if="submitted && !$v.createForm.name.required" class="text-right">
                {{ $t("message.requiredX", [$t("label.name")]) }}
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
            label="Conversion Factor"
            label-cols="4"
            label-align="left"
        >
            <b-form-input
                v-model.trim="createForm.conversionFactor"
                :class="{ 'is-invalid': submitted && !$v.createForm.conversionFactor.decimal }"
                autocomplete="off"
            />
            <b-form-invalid-feedback v-if="submitted && !$v.createForm.conversionFactor.decimal" class="text-right">
                {{ $t('message.invalidX', ['Conversion Factor']) }}
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
            label="Base Unit"
            label-cols="4"
            label-align="left"
        >
            <b-form-checkbox
                v-model="createForm.isBase"
                switch
                class="mt-2"
            />
        </b-form-group>
        <b-form-group
            label="Statistic"
            label-cols="4"
            label-align="left"
        >
            <b-form-checkbox
                v-model="createForm.isStatistic"
                switch
                class="mt-2"
            />
        </b-form-group>
        <b-form-group
            :label="$t('label.description')"
            label-cols="4"
            label-align="left"
        >
            <b-form-textarea
                v-model.trim="createForm.description"
            ></b-form-textarea>
        </b-form-group>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end w-100">
            <b-button
                type="button"
                variant="danger"
                class="mr-2 col-2"
                @click="$emit('done')"
            >{{ $t('label.cancel') }}</b-button>
            <b-button
                type="submit"
                variant="info"
                class="col-2"
                :disabled="!status.save"
            >
                <span v-if="status.save">
                    {{ propertyAreaUnitUUID ? $t('label.updateX', []) : $t('label.createX', []) }}
                </span>
                <div v-else>
                    <b-spinner small />
                </div>
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center align-items-center m-3">
        <b-spinner class="m-5" variant="info" role="status"></b-spinner>
    </div>
</template>
<script>
import { required, decimal } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { propertyAreaUnitMethods } from "@/state/api";
import { PROPERTY_AREA_UNIT_MODULE } from "@/state/api/propertyAreaUnit.state";

export default {
    props: {
        propertyAreaUnitUUID: {
            type: String,
            required: false,
        },
        searchCriteria: {
            type: Object,
            required: false,
        },
    },
    validations() {
        return {
            createForm: {
                name: { required },
                conversionFactor: { decimal },
            },
        };
    },
    async created() {
        await this.getPropertyAreaUnitData();
    },
    data() {
        return {
            submitted: false,
            createForm: this.defaultForm(),
        };
    },
    methods: {
        ...propertyAreaUnitMethods,
        defaultForm() {
            return {
                uuid: "",
                name: "",
                description: "",
                conversionFactor: "",
                isBase: false,
                isStatistic: false,
            };
        },
        async getPropertyAreaUnitData() {
            if (this.propertyAreaUnitUUID) {
                await this.getPropertyAreaUnit({ uuid: this.propertyAreaUnitUUID })
                    .then((result) => {
                        if (result?.success) {
                            this.createForm = {
                                uuid: this.data.uuid,
                                name: this.data.name,
                                description: this.data.description,
                                conversionFactor: this.data.conversionFactor,
                                isBase: this.data.isBase ? true : false,
                                isStatistic: this.data.isStatistic ? true : false,
                            };
                        }
                    });
            }
        },
        requestCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                };
                this.createPropertyAreaUnit({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        requestUpdate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                };
                this.updatePropertyAreaUnit({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
    computed: {
        ...mapState(PROPERTY_AREA_UNIT_MODULE, ['status']),
        data() {
            return this.$store.state.api.propertyAreaUnit.details;
        },
    },
}
</script>
